import { Me } from '@yandex-int/k-common/typings';
import { Button, SimpleText } from 'platform-components';
import { getMe } from 'platform-components/src/components/user/selectors';
import withSocketIO, { InjectedSocketIoProps } from 'platform-components/src/utils/hocs/with-socket-io';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import * as actions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';

interface OwnProps {
    onForceComplete?: () => void;
}

interface HOCProps extends WithRouterPathProps, InjectedSocketIoProps {}

interface StoreProps {
    courseId: number | null;
    clessonId: number;
    isForceCompleteAllowed: boolean;
    me: Me | null;
}

interface DispatchProps {
    forceCompleteLesson: typeof actions.forceCompleteLesson;
}

interface Props extends HOCProps, OwnProps, StoreProps, DispatchProps {}

export const ForceCompleteButton = (props: Props) => {
    const { forceCompleteLesson, courseId, clessonId, io, onForceComplete, isForceCompleteAllowed, me } = props;
    const handleCompleteLesson = () => {
        if (courseId) {
            const teacherId = me?.id;

            forceCompleteLesson(courseId, clessonId, io, teacherId, () => {
                if (onForceComplete) {
                    onForceComplete();
                }
            });
        }
    };

    return (
        <Button
            accent={Button.ACCENT.DANGER}
            className="side-panel__action-button"
            disabled={!isForceCompleteAllowed}
            onClick={handleCompleteLesson}
            view={Button.VIEW.PSEUDO}
        >
            <SimpleText id="lessonModal.header.completeLesson" />
        </Button>
    );
};

const mapStateToProps = (storeState: any): StoreProps => ({
    courseId: lessonSelectors.getLessonCourseId(storeState),
    clessonId: lessonSelectors.getCLessonId(storeState)!,
    isForceCompleteAllowed: lessonSelectors.getIsForceCompleteAllowed(storeState),
    me: getMe(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            forceCompleteLesson: actions.forceCompleteLesson,
        },
        dispatch
    );
};

export default withRouterPath(withSocketIO(connect(mapStateToProps, mapDispatchToProps)(ForceCompleteButton)));
